module.exports = __webpack_public_path__ + "img/EDI16_Z.96ca4c6b.png";